package com.parmartechnologies.business.feature.businessConnection.viewModel

import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.feature.businessConnection.model.BusinessConnection
import com.parmartechnologies.core.feature.businessConnection.network.BusinessConnectionCreateRequest
import com.parmartechnologies.core.feature.businessConnection.network.BusinessConnectionRetrieveRequest
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.business.feature.businessConnection.handler.BusinessConnectionHandler
import com.parmartechnologies.business.feature.businessConnection.network.BusinessConnectionNetwork
import com.parmartechnologies.business.feature.businessConnection.repository.BusinessConnectionRepository
import com.parmartechnologies.communication.core.handler.AuthHandler
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class BusinessConnectionViewModel :
    AppViewModel() {
    val repository: BusinessConnectionRepository =
        BusinessConnectionHandler.shared().repository

    val allData: StateFlow<List<BusinessConnection>>
        get() = repository.allLiveData

    val connectedBusiness: StateFlow<Business?>
        get() = repository.connectedBusiness

    val mediaFile: StateFlow<BusinessConnection>
        get() = repository.mediaFileLiveData


    fun retrieve() {
        val request =
            BusinessConnectionRetrieveRequest(
                BusinessHandler.shared().myBusinessId,
                AuthHandler.shared().UserID
            )
        startLoading()
        BusinessConnectionNetwork().retrieve(request) {
            stopLoading()
            if (!it?.payload.isNullOrEmpty()) {
                scope.launch {
                    repository.liveData.emit(it!!.payload)
                }
            }
        }
    }

    fun loadConnectedBusiness(
        businessConnection: BusinessConnection,
        callBack: (Business?) -> Unit
    ) {
        if (businessConnection.fromBusinessID == BusinessHandler.shared().myBusinessId) {
            businessConnection.toBusinessID.let {
                BusinessViewModel().getBusinessById(it) { business ->
                    scope.launch {
                        callBack(business)
                    }
                }
            }
        } else {
            businessConnection.fromBusinessID.let {
                BusinessViewModel().getBusinessById(it) { business ->
                    scope.launch {
                        callBack(business)
                    }
                }
            }
        }
    }


    fun create(toBusiness: Business, completion: ((Boolean) -> Unit) = {}) {
        val selfBusiness = BusinessHandler.shared().repository.myBusiness
        if (selfBusiness.value._id.isEmpty()) {
            return
        }
        if (toBusiness._id.isEmpty()) {
            return
        }
        startLoading()
        val request = BusinessConnectionCreateRequest(
            fromUserID = AuthHandler.shared().UserID,
            toUserID = toBusiness.UserID,
            fromBusinessID = selfBusiness.value._id,
            toBusinessID = toBusiness._id,
            name = selfBusiness.value.Name
        )
        BusinessConnectionNetwork().create(request) {
            stopLoading()
            if (!it?.payload?._id.isNullOrEmpty()) {
                scope.launch {
                    completion(true)
                }
            } else {
                completion(false)
            }
        }
    }
}